import type { EncodingProfile, EncodingStream } from "../api/EncoderAPI.types";
import type { FastAsset } from "../api/MediaAPI.types";

const ENCODING_IN_PROGRESS_STATUSES = ["queued", "transcoding"];

export function isStreamsEncoding(streams: EncodingStream[]): boolean {
  return streams.some((stream) =>
    ENCODING_IN_PROGRESS_STATUSES.includes(stream.status),
  );
}

export function isFastAssetEncoding(fastAsset: FastAsset | null): boolean {
  if (!fastAsset) return false;
  return (
    ENCODING_IN_PROGRESS_STATUSES.includes(fastAsset.hls_status) ||
    ENCODING_IN_PROGRESS_STATUSES.includes(fastAsset.mp4_status)
  );
}

export function isStreamsReadyToPlay(
  streams: EncodingStream[],
  fastAsset: FastAsset | null,
): boolean {
  return (
    streams.some(
      (stream) =>
        ["video", "audio", "d2g"].includes(stream.type) &&
        stream.status === "transcoded",
    ) || fastAsset?.mp4_status === "transcoded"
  );
}

export function isFastFramerateMismatch(
  selectedProfile: EncodingProfile | null,
  isFastOptionLocked: boolean,
  sourceMaxFramerate: number,
): boolean {
  if (!selectedProfile?.fast || isFastOptionLocked) return false;
  return selectedProfile.fast_framerate_target !== sourceMaxFramerate;
}
